(function() { window.GUID_1d1f4091_d0d4_4357_bb89_a533cda58d4f = { getGuid: function() { return "1d1f4091-d0d4-4357-bb89-a533cda58d4f"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_start extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "select-fees";
            }
            OnCheckIfCanContinue() {
                let checked = this.$StepDiv.find("input:checked");
                return checked.length !== 0;
            }
            OnSubmit() {
                let ids = this.$StepDiv.find("input[name^='player_']:checked").map((i, e) => { return e.name.split('_').pop().split('.'); }).get();
                let $PlayerIds = this.$StepDiv.find("#PlayerIds");
                $PlayerIds.val(ids.join(','));
            }
            OnLoad() {
                let me = this;
                let checkbox = $("#checkbox-payforother");
                if (checkbox.hasClass('checked')) {
                    $(".payForOthers").show();
                }
                else {
                    $(".payForOthers").hide();
                }
                // alert(checkbox.val());
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: "#checkbox-payforother",
                    callback: (checkbox, e) => {
                        if (checkbox.IsChecked) {
                            $(".payForOthers").show();
                        }
                        else {
                            $(".payForOthers").hide();
                        }
                    }
                });
            }
        }
        Controls.popupwizard_sportevent_fees_start = popupwizard_sportevent_fees_start;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=start.js.map
